import { render, staticRenderFns } from "./CryptoProviders.vue?vue&type=template&id=2e8e9ad6&scoped=true&"
import script from "./CryptoProviders.vue?vue&type=script&lang=js&"
export * from "./CryptoProviders.vue?vue&type=script&lang=js&"
import style0 from "./CryptoProviders.vue?vue&type=style&index=0&id=2e8e9ad6&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e8e9ad6",
  null
  
)

export default component.exports